import { Component, Prop, PropSync, Ref, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Logger } from 'fsts';
import rfd, { ReportFilterData } from '@/shared/model/smallPayloadModels/reportFilterData';
import { SaveList } from '@/shared/model/saveList';
import reportDown, { ReportDownload } from '@/shared/model/reportDownload';
import { CONST } from '@/shared/utils/Constants';
import GeneralUtils from '@/shared/utils/generalUtils';
import ReportDialogZRMitglieder from './report-dialog-zrmitglieder/report-dialog-zrmitglieder.vue';

const logger = new Logger('document-comment-dialog');
const articleModule = namespace('article');
const saveListModule = namespace('saveList');
const reportDownloadModule = namespace('reportDownload');

@Component({
  name: 'report-dialog',
  components: { 'report-dialog-zr-mitglieder': ReportDialogZRMitglieder},
})
export default class ReportDialog extends Vue {
  @Ref('observer-report-dialog-form')
  private observerReportDialogForm!: any;

  @articleModule.Action('getArticlesReport')
  private actionGetArticlesReport!: any;

  @articleModule.Action('getArticlesZipReport')
  private actionGetArticlesZipReport!: any;

  @articleModule.Action('getArticlesListZRMitglieder')
  private actionGetListZRMitglieder!: any;

  @articleModule.Action('getArticlesMitgliedZipReport')
  private actionGetArticlesMitgliedZipReport!: any;

  @articleModule.Action('getArticlesSuppliersFiltered')
  private actionGetArticlesSuppliers!: any;
  @articleModule.Getter('getArticlesSuppliers')
  private getArticlesSuppliers!: any;

  @saveListModule.Action('getSaveList')
  private actionGetSaveList!: any;

  @reportDownloadModule.Action('updateReportDownload')
  private actionUpdateReportDownload!: any;

  @Prop({ default: false })
  private dialog!: boolean;

  @Prop()
  private listModel!: any;

  private model!: SaveList;

  private isPdf = true;
  private isOneFile = false;
  private isOutputID = false;
  private isMitglied = false;
  private quantityCopies = '1';
  private zeroRecordsResponse = false;
  private isLoadingReport = false;

  private membersList: any[] = [];
  private membersListAll: any[] = [];

  get isErstInfoReport() {
    return this.listModel.type === 'erst_info_list';
  }

  get isSortimentsmatrixMFH() {
    return this.listModel.type === 'sortimentsmatrix_MFH';
  }

  async created() {
    await this.getSaveListData();
  }

  async getSaveListData() {
    await this.actionGetSaveList(this.listModel.id)
      .then(async (result: any) => {
        this.model = result;
        await this.getSuppliers();
      })
      .catch((err: any) => {
        logger.error(err);
      });
  }

  private async getSuppliers() {
    const payload: ReportFilterData = rfd.defaultData();

    this.preparePayload(payload);

    await this.actionGetArticlesSuppliers(payload)
      .then((result: any) => {
        this.suppliersBackend = result;
        this.populateSuppliersTable();
      })
      .catch((err: any) => {
        logger.error(err);
      });
  }

  populateSuppliersTable() {
    this.suppliersBackend.forEach((el: any) => {
      this.suppliers.push({
        name: `${el.lieferantenNummer} ${el.lieferantName}`,
        count: el.count,
        number: el.lieferantenNummer, // send to backend to filter `Suppliers` for report
        status: 'aktiv',
        updateAt: el.lastUpdated, // new Date().toISOString(),
      });
    });
  }

  search = '';
  singleSelect = false;
  selected = [];

  suppliersBackend = [];
  suppliers: any = [];

  get headers() {
    let headers: {
      text: string | any;
      value: string;
      sortable?: boolean;
      width?: string;
    }[] = [
      { text: this.$t('supplier_name'), value: 'name' },
      { text: this.$t('count'), value: 'count' },
      { text: this.$t('status'), value: 'status' },
      { text: this.$t('update_at'), value: 'updateAt' },
    ];
    return headers;
  }

  async clickSave() {
    const result = await this.observerReportDialogForm.validate();

    console.log(
      '------------------------------------------------------------  ===>>> this.quantityCopies  ',
      this.quantityCopies,
      '  this.isMitglied ',
      this.isMitglied,
      '  ',
      this.quantityCopies.length,
      '  this.selected?.length   ',
      this.selected?.length
    );

    const payload: ReportFilterData = rfd.defaultData();
    this.preparePayload(payload);
    // use `any` to avoid `System.ArgumentNullException: Value cannot be null. (Parameter 'request')` error
    const reportDownloadPayload: any = this.prepareReportDownloadPayload();
    if (result) {
      this.isLoadingReport = true;
      let quantityCopies = this.quantityCopies?.length != 0 ? +this.quantityCopies : 1;
      let quantityLieferant = this.selected?.length;
      if (this.isOneFile && !this.isMitglied) {
        if (quantityCopies <= 5) {
          var promiseAll: any = [];
          for (let index = 0; index <= quantityCopies - 1; index++) {
            payload.numberCopies = (index + 1).toString();
            console.log(
              '------------------------------- payload.numberCopies-----------------------------  ===>>>   ',
              payload.numberCopies
            );
            promiseAll.push(this.getReport(payload));
            //   this.getReport(payload)
            //     .then(async (result: any) => {
            //       await this.actionUpdateReportDownload(reportDownloadPayload);
            //     })
            //     .finally(() => {
            //       this.isLoadingReport = false;
            //     })
            //     .catch((err) => {});
          }
          await Promise.all(promiseAll)
            .then(async () => {
              await this.actionUpdateReportDownload(reportDownloadPayload);
            })
            .finally(() => {
              this.isLoadingReport = false;
            });
        } else {
          this.getZipReport(payload)
            .then(async (result: any) => {
              await this.actionUpdateReportDownload(reportDownloadPayload);
            })
            .finally(() => {
              this.isLoadingReport = false;
            });
        }
      } else if (!this.isMitglied) {
        console.log(
          '-------------------------------quantityCopies-----------------------------  ===>>>   ',
          quantityCopies,
          '   quantityLieferant   ',
          quantityLieferant,
          '   quantityCopies*quantityLieferant   ',
          quantityCopies * quantityLieferant
        );
        var promiseAll: any = [];
        let counter = 1;
        if (quantityCopies * quantityLieferant <= 15) {
          for (let index = 0; index <= quantityCopies - 1; index++) {
            this.selected.forEach(async (element: any) => {
              payload.numberCopies = counter.toString();
              payload.lieferantenNummer = element.number;
              promiseAll.push(this.getReport(payload));
              counter += 1;
            });
          }

          await Promise.all(promiseAll)
            .then(async () => {
              await this.actionUpdateReportDownload(reportDownloadPayload);
            })
            .finally(() => {
              this.isLoadingReport = false;
            });
        } else {
          // for (let index = 0; index <= quantityCopies - 1; index++) {
          //    payload.numberCopies = (index + 1).toString();
          // promiseAll.push(this.getZipReport(payload));
          await this.getZipReport(payload)
            .then(async () => {
              await this.actionUpdateReportDownload(reportDownloadPayload);
            })
            .finally(() => {
              this.isLoadingReport = false;
            });
          //}
        }
      } else if (this.isMitglied) {
        if (this.isOneFile) {
          let counter = 1;
          var promiseAll: any = [];

          // `Promise.all + forEach` generate ALL requests at once, so replaced it with below code
          // Await the promise result directly
          const membersList = this.membersList;// await this.actionGetListZRMitglieder();
          // payload.total = membersList.length;
          // Use `for of` loop to process items sequentially
          for (const  element of membersList) {
          // console.log('zzzzzzzzzz counterz:>> ', counter );

            const currentPayload = {
                // ... payload setup ...
                ...payload,
                numberCopies: counter.toString(),
                zrMitglied: element.ZRNummer,
                iteration: counter,
                totalFiles: membersList.length
            };

            // Wait for THIS request to finish before the loop continues
            await this.getReport(currentPayload); 
            counter += 1;
        }

        // Update the report download status after ALL reports are finished
          await this.actionUpdateReportDownload(reportDownloadPayload)
                .finally(() => {
                this.isLoadingReport = false;
              });
        } else {
          await this.getMitgliedZipReport(payload)
            .then(async (result: any) => {
              await this.actionUpdateReportDownload(reportDownloadPayload);
            })
            .finally(() => {
              this.isLoadingReport = false;
            });
        }
      }
    }
  }
  prepareReportDownloadPayload() {
    // use `any` to avoid `System.ArgumentNullException: Value cannot be null. (Parameter 'request')` error for `ReportDownload`
    const result: any = {};
    result.id = CONST.emptyGuid;
    result.saveListId = this.model.id;
    if (this.isSortimentsmatrixMFH) {
      this.isPdf = false;
    }

    result.outputType = this.isPdf ? 'PDF' : 'Excel';
    return result;
  }

  private async getReport(payload: ReportFilterData) {
    await this.actionGetArticlesReport(payload).catch((err: any) => {
      logger.error(err);
    });
  }

  private async getZipReport(payload: ReportFilterData) {
    await this.actionGetArticlesZipReport(payload).catch((err: any) => {
      logger.error(err);
    });
  }

  private async getMitgliedZipReport(payload: ReportFilterData) {
    await this.actionGetArticlesMitgliedZipReport(payload).catch((err: any) => {
      logger.error(err);
    });
  }

  private preparePayload(payload: any) {
    this.selected.forEach((el: any) => {
      payload.lieferantenNummern.push(el.number);
    });
    if (this.model?.warengruppen) {
      const groups = this.model?.warengruppen.split(',');
      payload.warengruppen = groups;
    }

    if (this.model?.articlesMarkerNames?.length > 0) {
      payload.articlesMarkerNames = this.model?.articlesMarkerNames;
    }
    if (this.model?.modelMarkerNames?.length > 0) {
      payload.modelMarkerNames = this.model?.modelMarkerNames;
    }
    if (this.model?.responsibleNames?.length > 0) {
      payload.responsibleNames = this.model?.responsibleNames;
    }

    if (this.model?.modelstatus) {
      const modelstatuses = this.model?.modelstatus.split(',');
      payload.modelstatuses = modelstatuses;
    }
    if (this.model?.vArtikelstatus) {
      const vArtikelstatuses = this.model?.vArtikelstatus.split(',');
      payload.vArtikelstatuses = vArtikelstatuses;
    }
    if (this.model?.vAuspraegungStatus) {
      const vAuspraegungStatuses = this.model?.vAuspraegungStatus.split(',');
      payload.vAuspraegungStatuses = vAuspraegungStatuses;
    }

    payload.name = this.model.name;
    payload.title = this.model.title;
    payload.isMaintained = this.model.vmEgepflegt;
    payload.reportType = this.model.type;
    payload.sort = this.model.sort;
    payload.isPdf = !this.isSortimentsmatrixMFH ? this.isPdf : false;
    payload.IsOneFileForSelectedSuppliers = this.isOneFile;
    payload.isOutputID = this.isOutputID;
    payload.isMitglied = this.isMitglied;
    payload.quantityCopies = this.quantityCopies?.length != 0 ? this.quantityCopies : '1';
    payload.isShowHerstellerArtikelNummer = this.model.isShowHerstellerArtikelNummer;

    payload.processId = GeneralUtils.generateCachePostfix(); 
  }

  filterInput(value: string) {
    console.log('value :>> ', value);
    // Only allow digits, a decimal point, and the negative sign
    const filteredValue = value.replace(/[^0-9.-]/g, '');
    console.log('filtered :>> ', filteredValue);
    this.quantityCopies = filteredValue;
  }

  sanitizeInput(value: string) {
    // Allow only digits (this will strip out anything except 0-9)
    let sanitizedValue = value.replace(/[^0-9]/g, ''); // Keep only numbers
    if (sanitizedValue === '') sanitizedValue = '1'; // Default to 0 if empty

    // Convert back to number and check max value
    let numericValue = parseInt(sanitizedValue, 10);
    if (numericValue > 50) {
      numericValue = 50; // Max value set to 50
    }

    // Update the value after sanitization and limit
    this.quantityCopies = numericValue.toString();
  }

  handleKeyDown(event: KeyboardEvent) {
    const key = event.key;
    const currentValue = this.quantityCopies;

    // Allow backspace, delete, arrow keys, etc.
    const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Enter'];

    // Allow digits 0-9
    const isDigit = /^[0-9]$/.test(key);

    // If it's not a digit or an allowed key, prevent the input
    if (!isDigit && !allowedKeys.includes(key)) {
      event.preventDefault();
    }

    // If the value is 50 or more, prevent entering any more digits
    if (parseInt(currentValue, 10) >= 50 && isDigit) {
      event.preventDefault();
    }
  }

  clickClose() {
    this.$emit('click:close');
  }

  changeReport(value: any) {
    console.log('-----------------changeReport-------------------------------------------  ===>>>  value ', value);
    if (value == false) {
      this.isOutputID = false;
      this.isMitglied = false;
      this.quantityCopies = '1';
    }
  }

  async changeSelectMitglied(value: any) {
    console.log(
      '-----------------changeSelectMitglied-------------------------------------------  ===>>>  value ',
      value
    );
    console.log('this.membersList.length :>> ', this.membersList.length);
    if (this.membersList.length == 0) {
      this.membersListAll = await this.actionGetListZRMitglieder();
      this.membersList = this.membersListAll;
    }
    if (value == false) {
      this.quantityCopies = '1';
    }
  }

  changeSelectOutputID(value: any) {
    console.log(
      '-----------------changeSelectOutputID-------------------------------------------  ===>>>  value ',
      value,
      '  isMitglied    ',
      this.isMitglied
    );
    if (value == false) {
      this.quantityCopies = '1';
      if (this.isMitglied) this.isMitglied = false;
    }
     console.log(
      '-----------------changeSelectOutputID-------------------------------------------  ===>>>  value ',
      value,
      '  isMitglied    ',
      this.isMitglied
    );
  }


  dialogZRMitgliederReport = {
    show: false,
    model: {},
    OnClose: () => {
      this.dialogZRMitgliederReport.show = false;
    },
  };

  private showZRMitgliederDialog() {
    console.log('-----------------showZRMitgliederDialog-------------------------------------------  ===>>>   ');
    this.dialogZRMitgliederReport.show = true;
    console.log('this.suppliers :>> ', this.membersListAll);
    this.dialogZRMitgliederReport.model = this.membersListAll;
  }

  private hasSelectionInMitgliedDialog = false;
  filterMitglied(mitglieds:any) {
    console.log('filterMitglied :>> ', mitglieds);
    this.membersList = mitglieds;
    this.hasSelectionInMitgliedDialog = true;
  }

}
